import { FC } from 'react';
import { Button } from 'rsuite';
import classnames from 'classnames';
import { TypeAttributes } from 'rsuite/esm/internals/types';
import styles from './tag.module.scss';

interface RsTagProps {
  label: string;
  color?: TypeAttributes.Color;
  appearance?: TypeAttributes.Appearance;
  size?: TypeAttributes.Size;
  className?: string;
}

export const RsTag: FC<RsTagProps> = ({
  label,
  appearance = 'default',
  size = 'md',
  color,
  className,
}) => {
  return (
    <Button
      appearance={appearance}
      color={color}
      size={size}
      classPrefix='tag'
      className={classnames(styles.RsTag, className)}
      as={'div'}
    >
      {label}
    </Button>
  );
};
